export default {
  openMenu: () => {
    return
  },
  closeMenu: () => {
    return
  }
}



// WEBPACK FOOTER //
// ./src/services/mainMenu.ts